const STORAGE_KEY = 'bg_workbench_welcome_date'

function todayKey() {
  const d = new Date()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${m}-${day}`
}

export function shouldShowWelcome() {
  try {
    return localStorage.getItem(STORAGE_KEY) !== todayKey()
  } catch (e) {
    return true
  }
}

export function markWelcomeShown() {
  try {
    localStorage.setItem(STORAGE_KEY, todayKey())
  } catch (e) {
    /* ignore */
  }
}
